import { Controller } from "stimulus";
import { EventGeckoChartRendered } from "../../events";
import { createPopper } from "@popperjs/core";
import { useClickOutside } from "stimulus-use";

export default class extends Controller {
  static targets = ["chart", "exportButton", "exportDropdownMenu"];

  chartInstance = null;
  chartUrls = null;

  selectedRange = null;

  connect() {
    if (this.hasExportButtonTarget) {
      useClickOutside(this, { element: this.exportButtonTarget });
    }
    window.addEventListener(EventGeckoChartRendered, this.onChartRerender.bind(this));

    this.chartUrls = JSON.parse(this.element.dataset.chartUrls);
    this.selectedRange = this.element.dataset.defaultRange;
  }

  handleRangeOptionChange(e) {
    const rangeKey = e.currentTarget.dataset.key;

    if (this.selectedRange === rangeKey) {
      return;
    }

    this.selectedRange = rangeKey;
    this.refreshChartSettings();
  }

  showExportDropdown(e) {
    if (!this.hasExportDropdownMenuTarget) {
      return;
    }

    e.stopPropagation();

    if (this.exportDropdownPopperInstance) {
      return this.hideExportDropdown(e);
    }

    this.exportButtonTarget.classList.add("selected");
    this.exportDropdownMenuTarget.classList.remove("tw-hidden");
    this.exportDropdownPopperInstance = createPopper(this.exportButtonTarget, this.exportDropdownMenuTarget, { placement: "bottom-start" });
  }

  hideExportDropdown(e) {
    if (!this.exportDropdownPopperInstance) {
      return;
    }

    this.exportButtonTarget.classList.remove("selected");
    this.exportDropdownMenuTarget.classList.add("tw-hidden");
    this.exportDropdownPopperInstance?.destroy();
    this.exportDropdownPopperInstance = null;
  }

  refreshChartSettings() {
    this.chartTarget.dataset.dataUrl = this.chartUrls?.[this.selectedRange];

    if (this.chartTarget.dataset.controller === "coins-chart") {
      this.chartTarget.dataset.coinsChartRerenderValue = true;
    } else {
      this.chartTarget.dataset.priceChartRerenderValue = true;
    }
  }

  onChartRerender(e) {
    this.chartInstance = e.detail.chart;
  }
}
